import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, MenuItem } from "@mui/material";

const LeitungsEbene = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
    return (
        <>
        <div>


            <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                <Stack spacing={2}>
                    <h1>Leitungsebene Form</h1>

                    <TextField name="leitungsebene_id" label='Leitungsebene id' {...register("leitungsebene_id")} />
                   
                    <TextField name="leitungsebene" label='Leitungsebene' {...register("leitungsebene")} />
                   




                    <Button type='submit' variant="outlined">Submit</Button>

                </Stack>

            </form>


        </div>
    </>
    )
}

export default LeitungsEbene